import { motion } from "framer-motion";

const CURTAIN = "/welcome/curtain.jpg";
const HEART = "/welcome/heart.jpg";
const OPEN_EASE = [0.76, 0, 0.24, 1];

function Panel({ side, open, duration }) {
  const left = side === "left";
  return (
    <motion.div
      data-testid={`curtain-${side}`}
      initial={false}
      animate={{ x: open ? (left ? "-104%" : "104%") : "0%", scaleX: open ? 0.7 : 1 }}
      transition={{ duration, ease: OPEN_EASE }}
      style={{ transformOrigin: left ? "left center" : "right center" }}
      className={`absolute inset-y-0 w-1/2 will-change-transform ${left ? "left-0" : "right-0"}`}
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${CURTAIN})`, transform: left ? "none" : "scaleX(-1)" }}
      />
      <div
        className={`absolute inset-y-0 w-24 sm:w-40 ${left ? "right-0 bg-gradient-to-l" : "left-0 bg-gradient-to-r"} from-black/60 to-transparent`}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-transparent to-black/60" />
    </motion.div>
  );
}

export default function Curtains({ open = false, heart = true, appear = true, duration = 1.7, className = "" }) {
  return (
    <div className={`absolute inset-0 overflow-hidden bg-[#1a0508] ${className}`} aria-hidden="true">
      <Panel side="left" open={open} duration={duration} />
      <Panel side="right" open={open} duration={duration} />
      {heart && (
        <div className="absolute inset-0 pointer-events-none sm:flex sm:items-center sm:justify-center">
          <motion.div
            data-testid="curtain-heart-spotlight"
            initial={appear ? { opacity: 0, scale: 0.85 } : false}
            animate={{ opacity: open ? 0 : 1, scale: open ? 1.15 : 1 }}
            transition={{ duration: open ? 0.6 : 2.2, ease: [0.16, 1, 0.3, 1], delay: open ? 0 : 0.2 }}
            className="absolute left-1/2 top-1/2 sm:static w-[125vmin] h-[125vmin] shrink-0 heart-spot"
            style={{ backgroundImage: `url(${HEART})` }}
          />
        </div>
      )}
      {heart && !open && <div className="absolute inset-0 spot-flicker pointer-events-none mix-blend-screen bg-[radial-gradient(circle_at_50%_45%,rgba(255,190,205,0.18),transparent_45%)]" />}
    </div>
  );
}
